/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useEffect, useState } from 'react';
import { format } from 'date-fns';

import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    padding: 8,
    marginLeft: 4,
    marginRight: 6,
    backgroundColor: '#FCFCFC',
  },

  header: {
    flexDirection: 'row',
  },

  container: {
    display: 'flex',
    alignItems: 'flex-start',
  },

  menu: {
    width: '100%',
    paddingRight: 4,
    flexDirection: 'row',
    borderTop: '1px solid #2E3135',
    borderBottom: '1px solid #2E3135',
  },

  content: {
    width: '100%',
    paddingRight: 4,
    justifyContent: 'space-between',
    flexDirection: 'row',
  },

  section: {
    margin: 8,
    maxWidth: 240,
    paddingLeft: 9,
    paddingRight: 9,
    paddingTop: 4,
    paddingBottom: 4,
    flexGrow: 1,
  },

  main: {
    alignContent: 'flex-start',
    textAlign: 'left',
    width: 280,
    maxWidth: 280,
    paddingLeft: 20,
    paddingRight: 10,
    paddingTop: 10,
    paddingBottom: 10,
    flexGrow: 1,
    borderBottom: '1px solid #E7E7E7',
  },

  image: {
    maxWidth: 180,
    objectFit: 'cover',
    width: '60%',
    height: 50,
  },

  title: {
    fontSize: 12,
    marginBottom: 6,
    fontWeight: 'bold',
  },

  subtitle: {
    fontSize: 10.5,
    fontWeight: 'normal',
    marginRight: 8,
  },

  boxtitle: {
    width: 280,
    maxWidth: 280,
    alignItems: 'flex-end',
    justifyContent: 'center',
    fontSize: 9,
  },

  text: {
    textAlign: 'center',
    alignItems: 'flex-start',
    fontSize: 9,
    marginLeft: 8,
  },
});

interface IClientDelivery {
  addressId: string;
  street: string;
  streetNumber: string;
  neighborhood: string;
  doorCode: string;
}

interface IClientLunch {
  order: string;
  quantity: number;
  lunchCost: number;
  description: string;
}

interface IClient {
  id: string;
  deliveryTime: string;
  client: string;
  total: number;
  quantity: number;
  deliveryDate: string;
  apartment: string;
  status: string;
  deliveryAddress: IClientDelivery[];
  lunchs: IClientLunch[];
}

interface IClientAll {
  data: IClient[];
  totalCost: number;
  totalQuantity: number;
  client: string;
}

interface IProps {
  startDate: string;
  endDate: string;
  client: IClientAll;
}

function PDFClientExplode({ client, endDate, startDate }: IProps) {
  return (
    <Document>
      <Page wrap size="A4" style={styles.page}>
        <View wrap={false} style={styles.header}>
          <View style={styles.section}>
            <Image style={styles.image} src="/img/logo.png" />
          </View>
          <View style={styles.section}>
            <Text style={styles.title}>Relatório de Cliente</Text>
            <Text style={styles.title}>Cliente: {client.client}</Text>
            <Text style={styles.subtitle}>
              Período de {startDate} a {endDate}
            </Text>
          </View>
          <View style={styles.section}>
            <Text style={styles.subtitle}>
              <Text style={styles.text}>
                Emissão: {format(new Date(), 'dd/MM/yyyy')}
              </Text>
            </Text>
            <Text style={styles.subtitle}>
              <Text style={styles.text}>
                Horário: {format(new Date(), 'HH:mm')}
              </Text>
            </Text>
          </View>
        </View>
        <View style={styles.container}>
          <View style={styles.menu}>
            <View style={styles.section}>
              <Text style={styles.boxtitle}>Data da Entrega</Text>
            </View>
            <View style={styles.section}>
              <Text style={styles.boxtitle}>Horário de Entrega</Text>
            </View>
            <View style={styles.section}>
              <Text style={styles.boxtitle}>Endereço de Entrega</Text>
            </View>
            <View style={styles.section} />
            <View style={styles.section}>
              <Text style={styles.boxtitle}>Quantidade</Text>
            </View>
            <View style={styles.section}>
              <Text style={styles.boxtitle}>Pedido</Text>
            </View>
            <View style={styles.section} />
            <View style={styles.section}>
              <Text style={styles.boxtitle}>Valor Gerado</Text>
            </View>
          </View>
          {client.data.map(i => (
            <View key={i.id} style={styles.content}>
              <View style={styles.main}>
                <Text style={styles.boxtitle}>{i.deliveryDate}</Text>
              </View>
              <View style={styles.main} />
              <View style={styles.main}>
                <Text style={styles.boxtitle}>
                  {i.deliveryTime.substr(0, 5)}
                </Text>
              </View>
              <View style={styles.main}>
                <Text style={styles.boxtitle}>
                  {i.deliveryAddress[0].street} -{' '}
                  {i.deliveryAddress[0].streetNumber}
                </Text>
              </View>
              <View style={styles.main} />
              <View style={styles.main}>
                <Text style={styles.boxtitle}>{i.quantity}</Text>
              </View>
              <View style={styles.main}>
                {i.lunchs.map((lunch, index) => (
                  <Text key={String(index)} style={styles.boxtitle}>
                    {lunch.quantity} - {lunch.order}
                  </Text>
                ))}
              </View>
              <View style={styles.main} />
              <View style={styles.main} />
              <View style={styles.main}>
                <Text style={styles.boxtitle}>{i.total}</Text>
              </View>
            </View>
          ))}
        </View>
      </Page>
    </Document>
  );
}

export default PDFClientExplode;
